import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

/**
 * Parse date/datetime string without timezone conversion.
 * Prevents the issue where "2024-01-15" is interpreted as UTC midnight
 * and then converted to local time (showing previous day in negative UTC offsets).
 *
 * @param dateStr - Date string in format "YYYY-MM-DD" or "YYYY-MM-DDTHH:mm:ss"
 * @returns Date object in local timezone
 */
export function parseDateLocal(dateStr: string): Date {
    // If it's a full ISO string with time (e.g., "2024-01-15T14:30:00")
    const isoMatch = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):?(\d{2})?/)
    if (isoMatch) {
        const [, year, month, day, hours, minutes, seconds = '0'] = isoMatch
        return new Date(Number(year), Number(month) - 1, Number(day), Number(hours), Number(minutes), Number(seconds))
    }
    // If it's just a date (e.g., "2024-01-15")
    const dateMatch = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})/)
    if (dateMatch) {
        const [, year, month, day] = dateMatch
        return new Date(Number(year), Number(month) - 1, Number(day))
    }
    // Fallback to native parsing
    return new Date(dateStr)
}
